<template>
    <div id="aps">
        <Card>
        <p slot="title">{{$t('ApprovalProcessSet.defaultApprovalProcess')}}</p>
        <Table
          class="box-margin"
          border
          :columns="columns"
          :loading="prevent"
          :data="MData"
          height="300"
          size="small"
        >
        <template slot-scope="{ row, index }" slot="action">
            <Icon @click="addPop = true,addFormItem = JSON.parse(JSON.stringify(row)),isMorE = true,isMorA = false,isMorY = false,isTJA = false,isTJE = false,isTJY = false,nowIndex = index" class="color-green" style="font-size: 23px;" type="md-create" />
        </template>
        <template slot-scope="{ row }" slot="action2">
            <Icon @click="addPop = true,addFormItem = JSON.parse(JSON.stringify(row)),isMorY = true,isMorE = false,isMorA = false,isTJA = false,isTJE = false,isTJY = false" class="color-yellow" style="font-size: 23px;" type="md-quote" />
        </template>
        <template slot-scope="{ row, index }" slot="action3">
            <Icon @click="upTo(row,index)" class="color-blue"  style="font-size: 23px;" type="md-arrow-round-up" />
        </template>
        <template slot-scope="{ row, index }" slot="action4">
            <Icon @click="dowTo(row,index)" class="color-blue" style="font-size: 23px;" type="md-arrow-round-down" />
        </template>
        <template slot-scope="{ index }" slot="action5">
            <Icon @click="delItem(index)" class="color-red" style="font-size: 23px;" type="md-close" />
        </template>
        </Table>
        <div>
          <Button :disabled="prevent" class="ivu-btn ivu-btn-dashed ivu-btn-long" @click="insertClick(),isMorA = true,isMorE = false,isMorY = false,isTJA = false,isTJE = false,isTJY = false">
            {{$t('ApprovalProcessSet.additionalApprovalSteps')}}
          </Button>
        </div>
        </Card>
        <Card style="margin-top: 30px" v-for="(item,Index) in TJSPList" :key="Index">
            <p slot="title">{{$t('ApprovalProcessSet.conditionsApprovalProcess')}}</p>
            <div style="margin-left: 80px">{{$t('ApprovalProcessSet.meetAtTheSameTime')}}
                <div style="display: inline-block">
                    <div class="ivu-tag ivu-tag-size-default ivu-tag-primary ivu-tag-dot ivu-tag-closable ivu-tag-checked" v-for="(item1,index) in TjlistArr[Index]" :key="index">
                            <span class="ivu-tag-text">
                                {{item1.condition_name}}
                            </span>
                    </div>
                    <Button class="ivu-btn ivu-btn-dashed" @click="editTJ(TjlistArr[Index],Index)"><i class="ivu-icon ivu-icon-ios-create"></i>{{$t('edit')}}</Button>
                </div>
            </div>
            <Table
            class="box-margin"
            border
            :columns="columns"
            :loading="prevent"
            :data="item"
            height="300"
            size="small"
            >
            <template slot-scope="{ row, index }" slot="action">
                <Icon @click="addPop = true,addFormItem = JSON.parse(JSON.stringify(row)),isTJA = false,isTJE = true,isTJY = false,isMorA = false,isMorE = false,isMorY = false,nowIndex = index,nowListIndex = Index" class="color-green" style="font-size: 23px;" type="md-create" />
            </template>
            <template slot-scope="{ row }" slot="action2">
                <Icon @click="addPop = true,addFormItem = JSON.parse(JSON.stringify(row)),isTJA = false,isTJE = false,isTJY = true,isMorA = false,isMorE = false,isMorY = false,nowListIndex = Index" class="color-yellow" style="font-size: 23px;" type="md-quote" />
            </template>
            <template slot-scope="{ row, index }" slot="action3">
                <Icon @click="upTo(row,index,item,Index)" class="color-blue"  style="font-size: 23px;" type="md-arrow-round-up" />
            </template>
            <template slot-scope="{ row, index }" slot="action4">
                <Icon @click="dowTo(row,index,item,Index)" class="color-blue" style="font-size: 23px;" type="md-arrow-round-down" />
            </template>
            <template slot-scope="{ index }" slot="action5">
                <Icon @click="delItem(index,item,Index)" class="color-red" style="font-size: 23px;" type="md-close" />
            </template>
            </Table>
            <div style="display: flex;justify-content: space-between">
            <Button :disabled="prevent" style="width: 80%" class="ivu-btn ivu-btn-dashed ivu-btn-long" @click="insertClick(),isTJA = true,isTJE = false,isTJY = false,isMorA = false,isMorE = false,isMorY = false,nowListIndex = Index">
                {{$t('ApprovalProcessSet.additionalApprovalSteps')}}
            </Button>
            <Button  style="width: 6%" type="primary" @click="upTJSPList(item,Index)" :disabled="(Index == 0 || prevent)">{{$t('ApprovalProcessSet.moveUp')}}</Button>
            <Button style="width: 6%" type="primary" @click="dowTJSPList(item,Index)" :disabled="(Index == TJSPList.length -1 || prevent)">{{$t('ApprovalProcessSet.moveDown')}}</Button>
            <Button :disabled="prevent" style="width: 6%" type="error" @click="delTJSPList(Index,Index)">{{$t('delete')}}</Button>
            </div>
        </Card>
        <Card style="margin-top: 30px">
        <!-- <p slot="title">{{$t('ApprovalProcessSet.buttonGroup')}}</p> -->
        <Form :disabled="prevent" style="display: flex;justify-content: space-between;">
            <div>
            <Button :disabled="prevent" @click="addTJSPList"  style="background-color: #2db7f5;border-color: #2db7f5;color: #fff"><Icon type="md-add" />{{$t('ApprovalProcessSet.addConditionApprovalProcess')}}</Button>
            </div>
            <div>
                <Button :disabled="prevent" type="primary" @click="comfBtn()" style="margin-right: 5px">{{$t('ApprovalProcessSet.preservation')}}</Button>
                <Button :disabled="prevent" @click="resBtn()">{{$t('cancel')}}</Button>
            </div>
        </Form>
        </Card>

        <Modal v-model="addPop" width="50%">
            <p slot="header" style="text-align: left">
                <Icon type="information-circled"></Icon>
                <span>{{$t('ApprovalProcessSet.approvalStepSetting')}}</span>
            </p>
            <div class="center" style="width: 98%; margin: auto;">
               <Form :model="addFormItem" :disabled="prevent"  ref="formValidate" :rules="ruleValidate" :label-width="155" label-position="right">
                   <Row style="margin-bottom: 15px"> 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.stepName')+$t('mh')" prop="step_name">
                                <Input v-model="addFormItem.step_name" />
                            </FormItem>
                        </Col>
                   </Row>
                   <Row style="margin-bottom: 15px"> 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.approvalMethod')+$t('mh')" prop="approval_type">
                                <Select :clearable="true"  v-model="addFormItem.approval_type">
                                    <Option
                                    :value="item.val"
                                    v-for="(item, i) in SPFSList"
                                    :key="i"
                                    >{{ item.name }}</Option
                                    >
                                </Select>
                            </FormItem>
                        </Col>
                   </Row>
                   <Row style="margin-bottom: 15px"> 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.approvalType')+$t('mh')" prop="auth_type">
                                <Select :clearable="true"  v-model="addFormItem.auth_type">
                                    <Option
                                    :value="item.val"
                                    v-for="(item, i) in SPLXList"
                                    :key="i"
                                    >{{ item.name }}</Option
                                    >
                                </Select>
                            </FormItem>
                        </Col>
                   </Row>
                   <Row style="margin-bottom: 15px" v-if="addFormItem.auth_type == 'A01'"> 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.approvalUser')+$t('mh')" prop="auth_name">
                                <div style="display: inline-block">
                                    <div class="ivu-tag ivu-tag-size-default ivu-tag-primary ivu-tag-dot ivu-tag-closable ivu-tag-checked" v-for="(item,index) in list" :key="index">
                                        <span class="ivu-tag-dot-inner"></span>
                                        <span class="ivu-tag-text">
                                            {{item.user_name}}
                                        </span>
                                        <i class="ivu-icon ivu-icon-ios-close" @click="delUser(index)"></i>
                                    </div>
                                </div>
                                <Button class="ivu-btn ivu-btn-dashed" @click="addUser"><i class="ivu-icon ivu-icon-ios-add"></i>{{$t('ApprovalProcessSet.add')}}</Button>
                            </FormItem>
                        </Col>
                   </Row>
                   <Row style="margin-bottom: 15px" v-if="addFormItem.auth_type == 'A03'"> 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.ApprovalDepartment')+$t('mh')" prop="auth_name">
                                <div style="display: inline-block">
                                    <div class="ivu-tag ivu-tag-size-default ivu-tag-primary ivu-tag-dot ivu-tag-closable ivu-tag-checked" v-for="(item,index) in orgList" :key="index">
                                        <span class="ivu-tag-dot-inner"></span>
                                        <span class="ivu-tag-text">
                                            {{item.cname}}
                                        </span>
                                        <i class="ivu-icon ivu-icon-ios-close" @click="delOrg(index)"></i>
                                    </div>
                                </div>
                                <Button class="ivu-btn ivu-btn-dashed" @click="addOrg()"><i class="ivu-icon ivu-icon-ios-add"></i>{{$t('ApprovalProcessSet.add')}}</Button>
                            </FormItem>
                        </Col>
                   </Row>
                   <Row style="margin-bottom: 15px" v-if="addFormItem.auth_type == 'A04'"> 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.levelSupervisor')+$t('mh')" prop="auth_name">
                                <Select :clearable="true"  v-model="addFormItem.auth_value">
                                    <Option
                                    :value="item.val"
                                    v-for="(item, i) in DJZGList"
                                    :key="i"
                                    >{{ item.name }}</Option
                                    >
                                </Select>
                            </FormItem>
                        </Col>
                   </Row>
                   <Row style="margin-bottom: 15px" v-if="addFormItem.auth_type == 'A06'"> 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.screenItem')+$t('mh')" prop="auth_name">
                                <Select :clearable="true"  v-model="addFormItem.conditionId">
                                    <Option
                                    :value="item.conditionId"
                                    v-for="(item, i) in HMXMList"
                                    :key="i"
                                    >{{ item.itemName }}</Option
                                    >
                                </Select>
                            </FormItem>
                        </Col>
                   </Row>
                   <Row style="margin-bottom: 15px" v-if="addFormItem.auth_type == 'A09'"> 
                        <Col span="18" offset="1">
                            <FormItem label="选择审批角色" >
                                <Select v-model="addFormItem.roleValueList" :clearable="true" placeholder="" multiple>
                                    <Option :value="item.roleId" v-for="item in roleList" :key="item.roleId">{{ item.roleDescribe }}</Option>
                                  </Select>
                            </FormItem>
                        </Col>
                    </Row>
                   <Row style="margin-bottom: 15px" v-if="addFormItem.auth_type == 'A10'"> 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.storedProcedureName')+$t('mh')" prop="auth_name">
                                <Input v-model="addFormItem.auth_value" />
                            </FormItem>
                        </Col>
                   </Row>
                   <Row style="margin-bottom: 15px" > 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.doesTheExaminerApproveRepeatedly')+$t('mh')" prop="repeat_flag">
                                <Select :clearable="true"  v-model="addFormItem.repeat_flag">
                                    <Option
                                    :value="item.val"
                                    v-for="(item, i) in SPRSFCFSPList"
                                    :key="i"
                                    >{{ item.name }}</Option
                                    >
                                </Select>
                            </FormItem>
                        </Col>
                   </Row>
                   <Row style="margin-bottom: 15px"> 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.overtimeApprovalMethod')+$t('mh')" prop="overtime_flag">
                                <Select :clearable="true"  v-model="addFormItem.overtime_flag">
                                    <Option
                                    :value="item.val"
                                    v-for="(item, i) in CSSPList"
                                    :key="i"
                                    >{{ item.name }}</Option
                                    >
                                </Select>
                            </FormItem>
                        </Col>
                   </Row>
                   <Row style="margin-bottom: 15px"> 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.timeOut')+$t('mh')">
                                <Select :clearable="true"  v-model="addFormItem.overtime_time">
                                    <Option
                                    :value="item.val"
                                    v-for="(item, i) in CSSJList"
                                    :key="i"
                                    >{{ item.name }}</Option
                                    >
                                </Select>
                            </FormItem>
                        </Col>
                   </Row>
                   <!-- <Row style="margin-bottom: 15px"> 
                        <Col span="18" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.screenDisplayDifferentiation')+$t('mh')">
                                <Select :clearable="true"  v-model="addFormItem.disp_flg">
                                    <Option
                                    :value="item.val"
                                    v-for="(item, i) in HMXSQFList"
                                    :key="i"
                                    >{{ item.name }}</Option
                                    >
                                </Select>
                            </FormItem>
                        </Col>
                   </Row> -->
               </Form>
            </div>
            <div
                slot="footer"
                class="footer"
                style="display: flex; width: 20%; margin: auto"
            >
                <div class="btn_group" >
                <Button type="primary" @click="addItem">{{$t('determine')}}</Button>
                <Button @click="addPop = false">{{$t('cancel')}}</Button>
                </div>
            </div>
         </Modal>
        <Modal v-model="addPop2" width="50%">
             <p slot="header" style="text-align: left">
        <Icon type="information-circled"></Icon>
        <span>{{$t('ApprovalProcessSet.userSearch')}}</span>
      </p>
      <div class="center" >
          <Form :model="userFormItem" :disabled="prevent" :label-width="85" label-position="left">
              <Row>
                  <Col span="5">
                    <FormItem :label="$t('ApprovalProcessSet.userID')+$t('mh')">
                        <Input v-model="userFormItem.user_id" />
                    </FormItem>
                  </Col>
                  <Col span="5" offset="1">
                    <FormItem :label="$t('ApprovalProcessSet.userName')+$t('mh')">
                        <Input v-model="userFormItem.user_name" />
                    </FormItem>
                  </Col>
                  <Col span="6" offset="1">
                    <FormItem :label="$t('ApprovalProcessSet.department')+$t('mh')">
                        <Select :clearable="true"  v-model="userFormItem.department_id">
                            <Option
                            :value="item.user_id"
                            v-for="(item, i) in SZBMList"
                            :key="i"
                            >{{ item.user_id }}</Option
                            >
                        </Select>
                    </FormItem>
                  </Col>
                  <Col span="1" offset="1">
                    <Button type="primary" @click="getUserList()">{{$t('query')}}</Button>
                  </Col>
              </Row>
          </Form>
          <Table
          class="box-margin"
          border
          :columns="userColumns"
          :loading="prevent"
          :data="userData"
          ref="userTable"
          @on-row-click ="clickRow"
          @on-selection-change="itemClick"
        >
        </Table>
        <Page v-if="userData.length != 0"  @on-change="pageChange" :total="pageInfo.itemCount" style="display:flex;justify-content: flex-end;" />
      </div>
      <div
        slot="footer"
        class="footer"
        style="display: flex; width: 20%; margin: auto"
      >
        <Form :disabled="prevent" class="btn_group">
          <Button type="primary" @click="addComUser">{{$t('determine')}}</Button>
          <Button @click="addPop2 = false">{{$t('cancel')}}</Button>
        </Form>
      </div>
        </Modal>
        <Modal v-model="tjPop" width="50%">
            <p slot="header" style="text-align: left">
                <Icon type="information-circled"></Icon>
                <span>{{$t('ApprovalProcessSet.processConditionSetting')}}</span>
            </p>
            <div class="center">
               <div v-for="(item,index) in Tjlist" :key="index">
                   <Divider plain orientation="left">{{$t('ApprovalProcessSet.conditions')}}{{index + 1}}</Divider>
                    <Row>
                       <Col span="2" offset="1">
                            <Button>
                                <Icon type="md-close" @click="delTjList(index)"/>
                            </Button>
                        </Col>
                        <Col span="6" offset="1">
                             <Select :clearable="true"  v-model="item.condition_id">
                                <Option
                                :value="item.condition_id"
                                v-for="(item, i) in TJPDList1"
                                :key="i"
                                >{{ item.item_name }}</Option
                                >
                            </Select>
                        </Col>
                         <Col span="6" offset="1">
                             <Select :clearable="true"  v-model="item.condition_type">
                                <Option
                                :value="item.val"
                                v-for="(item, i) in TJPDList2"
                                :key="i"
                                >{{ item.name }}</Option
                                >
                            </Select>
                        </Col>
                         <Col span="6" offset="1">
                            <Input v-model="item.condition_value" />
                        </Col>
                    </Row>
               </div>
            </div>
            <div
                slot="footer"
                class="footer"
                style="display: flex; width: 30%; margin: auto"
            >
                <Form class="btn_group" :disabled="prevent">
                <Button type="success"  @click="addTJList()">{{$t('ApprovalProcessSet.additionalConditions')}}</Button>
                <Button type="primary" @click="comAddTJList()">{{$t('determine')}}</Button>
                <Button @click="tjPop = false">{{$t('cancel')}}</Button>
                </Form>
            </div>
         </Modal>
         
        <Modal v-model="orgFlg" width="50%" @on-ok="addOrgCom" @on-cancel="orgFlg = false">
            <p slot="header" style="text-align: left">
                <Icon type="information-circled"></Icon>
                <span>{{$t('ApprovalProcessSet.userSearch')}}</span>
            </p>
            <div class="center" >
                <Form :model="orgFormItem" :disabled="prevent" :label-width="100" label-position="left">
                    <Row>
                        <Col span="6">
                            <FormItem :label="$t('ApprovalProcessSet.DepartmentID')+$t('mh')">
                                <Input v-model="orgFormItem.code" />
                            </FormItem>
                        </Col>
                        <Col span="6" offset="1">
                            <FormItem :label="$t('ApprovalProcessSet.DepartmentName')+$t('mh')">
                                <Input v-model="orgFormItem.cName" />
                            </FormItem>
                        </Col>
                        <Col span="1" offset="1">
                            <Button type="primary" @click="getOrgList()">{{$t('query')}}</Button>
                        </Col>
                    </Row>
                </Form>
                <Table
                class="box-margin"
                :columns="orgColumns"
                :loading="prevent"
                :data="orgData"
                @on-selection-change="orgClick"
                >
                </Table>
                <Page v-if="orgData.length != 0"  @on-change="pageChange1" :total="pageInfo1.itemCount" style="display:flex;justify-content: flex-end;" />
            </div>
        </Modal>
    </div>
</template>
<script>
import axios from "axios";
import Vue from 'vue';
export default {
    data() {
        const validateAuth_name = (rule, value, callback) => {
                if (this.list.length == 0 && this.addFormItem.auth_type == 'A01') {
                    callback(new Error(this.$t('ApprovalProcessSet.pleaseSelectAtLeastOneReviewer')));
                }else if(!this.addFormItem.auth_value && (this.addFormItem.auth_type == 'E01' || this.addFormItem.auth_type == 'E02' || this.addFormItem.auth_type == 'E04')) {
                    callback(new Error(this.$t('ApprovalProcessSet.pleaseSelectAtLeastOneReviewer')));
                }else if(!value && this.addFormItem.auth_type != 'A01' && this.addFormItem.auth_type == 'E01' && this.addFormItem.auth_type == 'E02') {
                    callback(new Error(this.$t('ApprovalProcessSet.pleaseSelectAtLeastOneReviewer')));
                }else {
                    callback();
                }
            };
        return {
            pageInfo: {
                itemCount: 0,
                pageNo: 1
            },
            pageInfo1: {
                itemCount: 0,
                pageNo: 1
            },
            orgselectList:[],
            columns: [
                {
                title: this.$t('ApprovalProcessSet.steps'),
                type: 'index',
                width: 60,
                align: 'center'
                },
                {
                title: this.$t('ApprovalProcessSet.stepName'),
                key: "step_name",
                align: 'center'
                },
                {
                title: this.$t('ApprovalProcessSet.approvalMethod'),
                key: "approval_type",
                align: 'center',
                render: (h, params) => {
                    var name1 = ''
                        this.SPFSList ? this.SPFSList.map((item,index) => {
                        if (item.val == params.row.approval_type) {
                            name1 = item.name
                        }
                    }) : ''
                    return h(
                        "span",
                        name1
                    );
                },
                },
                {
                title: this.$t('ApprovalProcessSet.approvalType'),
                key: "auth_type",
                align: 'center',
                render: (h, params) => {
                    var name1 = ''
                        this.SPLXList ? this.SPLXList.map((item,index) => {
                        if (item.val == params.row.auth_type) {
                            name1 = item.name
                        }
                    }) : ''
                    return h(
                        "span",
                        name1
                    );
                },
                },
                {
                title: this.$t('approvalRecord.approvedBy'),
                key: "auth_name",
                align: 'center',
                // render: (h, params) => {
                //     var name1 = ''
                //    params.row.list ? params.row.list.map((item,index) => {
                //         if (params.row.list.length == 1) {
                //             name1 = item.name
                //         } else if ((params.row.list.length-1) == index) {
                //             name1 += item.name
                //         }else {
                //             name1 += item.name + ','
                //         }
                //     }) : ''
                //     return h(
                //         "span",
                //        name1
                //     );
                   
                // },
                },
                {
                title: this.$t('ApprovalProcessSet.doesTheExaminerApproveRepeatedly'),
                key: "repeat_flag",
                align: 'center',
                render: (h, params) => {
                    var name1 = ''
                        this.SPRSFCFSPList ? this.SPRSFCFSPList.map((item,index) => {
                        if (item.val == params.row.repeat_flag) {
                            name1 = item.name
                        }
                    }) : ''
                    return h(
                        "span",
                        name1
                    );
                },
                },
                {
                title: this.$t('ApprovalProcessSet.overtimeApprovalMethod'),
                key: "overtime_flag",
                align: 'center',
                render: (h, params) => {
                    var name1 = ''
                        this.CSSPList ? this.CSSPList.map((item,index) => {
                        if (item.val == params.row.overtime_flag) {
                            name1 = item.name
                        }
                    }) : ''
                    return h(
                        "span",
                        name1
                    );
                },
                },
                {
                title: this.$t('ApprovalProcessSet.timeOut'),
                // key: "timeout_duetime",
                key:"overtime_time",
                align: 'center',
                render: (h, params) => {
                    var name1
                    this.CSSJList.map(item => {
                        if (item.val == params.row.overtime_time) {
                                name1 = item.name
                        }
                    })
                    return h(
                        "span",
                       name1
                    );
                },
                },
                {
                title: this.$t('edit'),
                slot: "action",
                width: 60,
                align: 'center'
                },
                {
                title: this.$t('ApprovalProcessSet.quote'),
                slot: "action2",
                width: 60,
                align: 'center'
                },
                {
                title: this.$t('ApprovalProcessSet.moveUp'),
                slot: "action3",
                width: 60,
                align: 'center'
                },
                {
                title: this.$t('ApprovalProcessSet.moveDown'),
                slot: "action4",
                width: 60,
                align: 'center'
                },
                {
                title: this.$t('delete'),
                slot: "action5",
                width: 60,
                align: 'center'
                },
            ],
            TJSPList: [
                // [
                //     {
                //     step_name: 1,
                //     }
                // ],
                ],
            TjlistArr: [
            ],
            MData: [],
            userColumns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                title: this.$t('ApprovalProcessSet.userID'),
                key: "user_id",
                },
                {
                title: this.$t('ApprovalProcessSet.userName'),
                key: "user_name",
                },
                {
                title: this.$t('ApprovalProcessSet.department'),
                key: "department_id",
                },
            ],
            userData: [],
            prevent: false,
            addPop: false,
            addPop2: false,
            tjPop: false,
            addFormItem:{
                step_name: '',
                approval_type: '',
                auth_type: '',
                auth_name: '',
                repeat_flag: '',
                // timeout_flag: '',
                overtime_flag:'',
                list: [],
            },
            userFormItem: {

            },
            TJFormItem: {},
            SPFSList: [
                {
                    val: "0",
		            name: this.$t('ApprovalProcessSet.countersignature')
                },
                {
                    val:"1",
                    name:this.$t('ApprovalProcessSet.orSign')
                }
            ],
            SPLXList: [
                {
                    val:"A01",
                    name:"A01:"+this.$t('ApprovalProcessSet.specifiedUserApproval')
                },
                {
                    val:"A03",
                    name:"A03:"+this.$t('ApprovalProcessSet.approvalDesignatedLevelSupervisor')
                },
                {
                    val:"A04",
                    name:"A04:"+this.$t('ApprovalProcessSet.approvalDesignatedLevelDeputyDirector')
                },
                {
                    val:"A06",
                    name:"A06:"+this.$t('ApprovalProcessSet.conditionApproval')
                },
                {
                    val:"A09",
                    name:"A09:"+this.$t('ApprovalProcessSet.roleApproval')
                },
                {
                    val:"A10",
                    name:"A10:"+this.$t('ApprovalProcessSet.customStoredProcedureApproval')
                },
            ],
            CSSPList: [
                {
                    val: '0',
                    name: this.$t('ApprovalProcessSet.none'),
                },
                {
                    val: '1',
                    name: this.$t('ApprovalProcessSet.refuseProcessing'),
                },
                {
                    val: '2',
                    name: this.$t('ApprovalProcessSet.approvalProcessing'),
                },
            ],
            CSSJList: [
                 {
                    val:"PT1H",
                    name:this.$t('ApprovalProcessSet.anHour')
                },
                 {
                    val:"P1D",
                    name:this.$t('ApprovalProcessSet.oneDay')
                },
                 {
                    val:"P7D",
                    name:this.$t('ApprovalProcessSet.sevenDays')
                },
                 {
                    val:"P1W",
                    name:this.$t('ApprovalProcessSet.aWeek')
                },
                 {
                    val:"P1M",
                    name:this.$t('ApprovalProcessSet.oneMonth')
                },
                 {
                    val:"P3M",
                    name:this.$t('ApprovalProcessSet.threeMonths')
                },
                 {
                    val:"P6M",
                    name:this.$t('ApprovalProcessSet.sixMonths')
                },
                 {
                    val:"P10M",
                    name:this.$t('ApprovalProcessSet.tenMonths')
                },
                 {
                    val:"P1Y",
                    name:this.$t('ApprovalProcessSet.aYear')
                },
            ],
            HMXSQFList: [
                {
                    val:"0",
                    name:this.$t('ApprovalProcessSet.applicantEditor')
                },
                {
                    val:"1",
                    name:this.$t('ApprovalProcessSet.supervisorCanEdit')
                },
                {
                    val:"2",
                    name:this.$t('ApprovalProcessSet.hrCanBeEdited')
                },
                {
                    val:"3",
                    name:this.$t('ApprovalProcessSet.supervisorReadOnly')
                },
                {
                    val:"4",
                    name:this.$t('ApprovalProcessSet.hrReadOnly')
                },
            ],
            SPRSFCFSPList:[
                {
                    val:"0",
                    name:this.$t('yes')
                },
                {
                    val:"1",
                    name:this.$t('no')
                },
            ],
            DJZGList: [
                {
                    val:"1",
		            name:"1"+this.$t('ApprovalProcessSet.levelSupervisor')
                },
                {
                    val:"2",
		            name:"2"+this.$t('ApprovalProcessSet.levelSupervisor')
                },
                {
                    val:"3",
		            name:"3"+this.$t('ApprovalProcessSet.levelSupervisor')
                },
                {
                    val:"4",
		            name:"4"+this.$t('ApprovalProcessSet.levelSupervisor')
                },
                {
                    val:"5",
		            name:"5"+this.$t('ApprovalProcessSet.levelSupervisor')
                },
                {
                    val:"6",
		            name:"6"+this.$t('ApprovalProcessSet.levelSupervisor')
                },
                {
                    val:"7",
		            name:"7"+this.$t('ApprovalProcessSet.levelSupervisor')
                },
                {
                    val:"8",
		            name:"8"+this.$t('ApprovalProcessSet.levelSupervisor')
                },
                {
                    val:"9",
		            name:"9"+this.$t('ApprovalProcessSet.levelSupervisor')
                },
                {
                    val:"10",
		            name:"10"+this.$t('ApprovalProcessSet.levelSupervisor')
                },
            ],
            HMXMList: [],
            SZBMList: [],
            selection: [],
            Tjlist: [],
            TJPDList1: [],
            TJPDList2: [
                {
                val:"0",
		        name:this.$t('ApprovalProcessSet.equivalentTo')
                },
                {
                val:"1",
		        name:this.$t('ApprovalProcessSet.contain')
                },
                {
                val:"5",
		        name:this.$t('ApprovalProcessSet.greaterThan')
                },
                {
                val:"4",
		        name:this.$t('ApprovalProcessSet.lessThan')
                },
                {
                val:"6",
                name:this.$t('ApprovalProcessSet.notEqualTo')
                }

            ],
            
            ruleValidate: {
                    step_name: [
                        { required: true, message: this.$t('ApprovalProcessSet.pleaseFillInTheStepName') }
                    ],
                    approval_type: [
                        { required: true, message: this.$t('ApprovalProcessSet.pleaseSelectTheApprovalMethod') }
                    ],
                    auth_type: [
                        { required: true, message: this.$t('ApprovalProcessSet.pleaseSelectApprovalType') }
                    ],
                    auth_name: [
                        { required: true,validator: validateAuth_name}
                    ],
                    repeat_flag: [
                        { required: true, message: this.$t('ApprovalProcessSet.pleaseSelectWhetherToApproveRepeatedly') }
                    ],
                    overtime_flag: [
                        { required: true, message: this.$t('ApprovalProcessSet.pleaseSelectOvertimeApprovalMethod') }
                    ],
            },
            isMorE: false,
            isMorA: false,
            isMorY: false,
            isTJE: false,
            isTJA: false,
            isTJY: false,
            nowIndex: '',
            nowListIndex: '',
            nowTJIndex: '',
            params: {},
            list: [],
            delList: [],
            orgFlg: false,
            orgFormItem: {},
            orgColumns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                title: this.$t('ApprovalProcessSet.DepartmentID'),
                key: "code",
                },
                {
                title: this.$t('ApprovalProcessSet.DepartmentName'),
                key: "cname",
                },
            ],
            orgData: [

            ],
            orgList:[],
            roleList:[],
        }
    },
    watch: {
        addPop(val) {
            if (val && (this.isMorA || this.isTJA)) {
                this.addFormItem = {}
                this.$refs['formValidate'].resetFields();
            }
            if (val && (this.isMorE || this.isMorY || this.isTJE || this.isTJY)) {
                if (this.addFormItem.auth_type == 'A01') {
                    var userKeyList = JSON.parse(JSON.stringify(this.addFormItem.auth_value.split(','))) 
                    var userNameList = JSON.parse(JSON.stringify(this.addFormItem.auth_name.split(','))) 
                    this.list = []
                    userNameList.map((item,index) => {
                        var obj = {
                            user_id: userKeyList[index],
                            user_name: userNameList[index]
                        }
                        this.list.push(obj) 
                    })
                }
                if (this.addFormItem.auth_type == 'A03') {
                    var userKeyList = JSON.parse(JSON.stringify(this.addFormItem.auth_value.split(','))) 
                    var userNameList = JSON.parse(JSON.stringify(this.addFormItem.auth_name.split(','))) 
                    this.orgList = []
                    userNameList.map((item,index) => {
                        var obj = {
                            code: userKeyList[index],
                            cname: userNameList[index]
                        }
                    this.orgList.push(obj) 
                    })
                }
            }
            if (!val) {
                // this.addFormItem = {}
                this.list = []
                this.orgList = []
                // this.$refs['formValidate'].resetFields();
            }
        },
        addPop2(val) {
            if (!val) {
                // this.userFormItem = {}
                if (this.list.length != 0) {
                    this.list = Array.from(new Set(this.list))
                    this.delList = Array.from(new Set(this.delList))
                    if (this.delList.length != 0) {
                        this.list.map((item,index) => {
                        this.delList.map(item1 => {
                            if (item.user_id == item1) {
                                this.list.splice(index,1)
                            }
                        })
                    })
                    }
                   
                }
            } 
            if (val) {
                this.delList = []
                // this.userFormItem.user_name = this.addFormItem.auth_name
                // this.userFormItem.user_id = this.addFormItem.auth_value
                
                this.getUserList()
            }
        },
        tjPop(val) {
            if (!val) {
                this.Tjlist = []
            }
        },
        'addFormItem.auth_type'(val){
            if (val == 'A06') {
                this.getConditionInfo()
            }else{

            }
        }
    },
    mounted() {
        this.params = this.$route.query
        this.getData()
        this.getTJPDList1()
        // 获取角色List
        this.getRoleList()
    },
    updated() {
        if (this.addPop2) {
            if(this.list.length != 0) {
            this.list.map(item => {
                this.userData.map ((item1,index) => {
                    if (item.user_id == item1.user_id) {
                        this.$refs.userTable.objData[index]._isChecked = true;
                    }
                }) 
            })
            }
        }
    },
    methods: {
        getRoleList(){
            let obj = {
                pageNO : 1,
                pageSize:1000
            }
            axios.post("/roleMaster/selectAllRoleMasterInfo", obj).then((res) => {
                this.roleList = res;
            });
        },
        orgClick(selection){
            this.orgselectList = selection
        },
        getConditionInfo(){
            axios.post("/ApprovalSetting/SearchConditionInfo", {applyId :this.params.apply_id}).then((res) => {
                this.HMXMList = res
            });
        },
        addOrg(){
            this.orgFlg = true
            this.getOrgList()
        },
        getOrgList(i){
            if (!i) {
                this.pageInfo1 ={
                    itemCount: 0,
                    pageNo: 1,
                    pageSize: 10,
                }
            }
            this.prevent = true
            let arr = {
                pageNo : this.pageInfo1.pageNo,
                pageSize : this.pageInfo1.pageSize,
                ...this.orgFormItem
            }
            axios.post("/Organization/getOrganizationList", arr).then((res) => {
                this.orgData = res.data
                this.pageInfo1.itemCount= parseInt(res.pageInfo.total) 
                this.prevent = false
            });
        },
        resBtn() {
            this.prevent = true
            this.$router.push('/A5A541E7BA29A93237F9D2086C913F33/93691ABC763FC67F')
        },
        comfBtn() {
            this.prevent = true
            var AllTableList = [...this.MData]
            var AllTjList = []
            this.TJSPList.map((item,index1) => {
                item.map((item1,index2) => {
                    item1.flow_index = index1 + 1
                    item1.step_index = index2 + 1
                    this.$set(item,'item1',item1)
                })
                AllTableList = [...AllTableList,...item]
            })
            this.TjlistArr.map((item,index1) => {
                item.map((item1,index2) => {
                    item1.flow_index = index1 + 1
                    item1.condition_index = index2 + 1
                    this.$set(item,'item1',item1)
                })
                AllTjList = [...AllTjList,...item]
            })
            AllTableList.map(item => {
                if (item.auth_type != "E04") {
                    item.auth_item_display = item.auth_name.split(',')
                    item.auth_item_ids = item.auth_value.split(',')
                }
                item.apply_id = this.params.apply_id
                item.version_id = this.params.version_id
            })
             AllTjList.map(item => {
                item.apply_id = this.params.apply_id
                item.version_id = this.params.version_id
            })
            let arr = [
                {
                "objData1":this.params,
                "stringData1":"A5A541E7BA29A93237F9D2086C913F33",
                "stringData2":"56CEB60557E4058A",
                "stringData3":"11",
                "type":"P04"
                },
                {
                "objData1":this.params,
                "stringData1":"A5A541E7BA29A93237F9D2086C913F33",
                "stringData2":"56CEB60557E4058A",
                "stringData3":"12",
                "type":"P04"
                },
                {
                    "listData1": AllTableList,
                    "stringData1": "A5A541E7BA29A93237F9D2086C913F33",
                    "stringData2": "56CEB60557E4058A",
                    "stringData3": "11",
                    "type": "P01"
                    },
                {
                    "listData1": AllTjList,
                    "stringData1": "A5A541E7BA29A93237F9D2086C913F33",
                    "stringData2": "56CEB60557E4058A",
                    "stringData3": "12",
                    "type": "P01"
                }
            ]
            axios.post('/process/execute',arr).then((res) =>{
                this.prevent = false
                if (res) {
                     this.$Message.success(this.$t('ApprovalProcessSet.setSuccessfully'));
                     this.$router.push('/A5A541E7BA29A93237F9D2086C913F33/93691ABC763FC67F')
                }
            })

        },
        orgRemoveArr(arr){
            this.orgList.map((item,index) => {
                if (item.code == arr.code) {
                    this.orgList.splice(index,1)
                }
            })
        },
        RemoveArr(arr) {
            this.list.map((item,index) => {
                if (item.user_id == arr.user_id) {
                    this.list.splice(index,1)
                }
            })
        },
        pageChange(val) {
            this.pageInfo.pageNo = val;
            this.getUserList(1);
            },
        pageChange1(val) {
            this.pageInfo1.pageNo = val;
            this.getOrgList(1);
        },
        getUserList(i) {
            if (!i) {
                this.pageInfo={
                    itemCount: 0,
                    pageNo: 1,
                    pageSize: 10,
                }
            }
            this.prevent = true
            let arr = [
                    {
                    "objData1": this.userFormItem,
                    "objData2": {"pageNo":this.pageInfo.pageNo},
                    "stringData1": "A5A541E7BA29A93237F9D2086C913F33",
                    "stringData2": "56CEB60557E4058A",
                    "stringData3": "21",
                    "type": "P00"
                    }
                    ]
            axios.post('/process/execute',arr).then((res) =>{
                this.prevent = false
                if (res) {
                    this.userData = res[0].dataList
                    this.pageInfo = res[0].pageInfo
                    
                }
            })
        },
        getTJPDList1() {
            let arr = [
                    {
                    "objData1": this.params,
                    "stringData1": "A5A541E7BA29A93237F9D2086C913F33",
                    "stringData2": "56CEB60557E4058A",
                    "stringData3": "2",
                    "type": "P00"
                    }
                    ]
            axios.post('/process/execute',arr).then((res) =>{
                if (res) {
                    this.TJPDList1 = res[0]
                }
            })
        },
        getData() {
            this.prevent = true
            let arr = [
                    {
                    "objData1": this.params,
                    "stringData1":"A5A541E7BA29A93237F9D2086C913F33",
                    "stringData2":"56CEB60557E4058A",
                    "stringData3":"11",
                    "type":"P00"
                    },
                    {
                    "objData1": this.params,
                    "stringData1":"A5A541E7BA29A93237F9D2086C913F33",
                    "stringData2":"56CEB60557E4058A",
                    "stringData3":"12",
                    "type":"P00"
                    }
                    ]
            axios.post("/process/execute", arr).then((res) => {
                    this.prevent = false
                    this.MData = []
                    var arr = []
                    if (res) {
                        res[0].map((item,index) => {
                            if(item.flow_index == '0') {
                                this.MData.push(item)
                            }
                            if (item.flow_index != '0') {
                                arr.push(JSON.parse(JSON.stringify(item.flow_index)))
                            }
                            arr = Array.from(new Set(arr))
                            this.TJSPList.length = arr.length
                            this.TjlistArr.length = arr.length
                        })
                        this.MData.map((item)=>{
                            item.roleValueList=item.auth_value.split(",")
                        })
                        arr.map(item1 => {
                             var arr1 = []
                             var arr2 = []
                             res[0].map(item => {
                                 if (item.flow_index == item1 && item.flow_index != 0) {
                                    item.roleValueList=item.auth_value.split(",")
                                    arr1.push(item)
                                    }
                             })
                             res[1].map(item => {
                                if (item.flow_index == item1 && item.flow_index != 0) {
                                    item.roleValueList=item.auth_value.split(",")
                                    arr2.push(item)
                                }
                             })
                         
                            this.TJSPList[item1 - 1] = arr1
                            this.TjlistArr[item1 - 1] = arr2
                            })
                    }
                });
        },
        comAddTJList() {
            this.Tjlist.map((item,index) => {
                if (item.condition_id && item.condition_type && item.condition_value) {
                    var name1 = ''
                    var name2 = ''
                    this.TJPDList1.map(item1 => {
                        if (item.condition_id == item1.condition_id) {
                            name1 = item1.item_name
                        }
                    })
                    this.TJPDList2.map(item2 => {
                        if (item.condition_type == item2.val) {
                            name2 = item2.name
                        }
                    })
                    item.condition_name = name1 + ' ' + name2 + ' ' + item.condition_value
                    item.flow_index = this.nowTJIndex + 1
                    item.condition_index = index + 1
                    this.TjlistArr[this.nowTJIndex].splice(index,1,JSON.parse(JSON.stringify(item)))
                    this.tjPop = false
                }
            })
        },
        delTjList(index) {
            this.Tjlist.splice(index,1)
            this.$set(this.TjlistArr,this.nowTJIndex,this.Tjlist)
        },
        addTJList() {
            this.Tjlist.push({})
        },
        upTJSPList(row,index) {
            if(index != 0) {
                this.TJSPList[index] = this.TJSPList[index-1]
                var TjArr = []
                TjArr = this.TjlistArr[index - 1]
                this.TjlistArr[index - 1] = this.TjlistArr[index]
                this.TjlistArr[index] = TjArr
                this.TJSPList[index].map(item => {
                    item.flow_index = item.flow_index + 1
                })
                row.map(item => {
                    item.flow_index = item.flow_index - 1
                })
                this.TjlistArr[index].map(item => {
                    item.flow_index = item.flow_index + 1
                })
                this.TjlistArr[index - 1].map(item => {
                    item.flow_index = item.flow_index - 1
                })
                this.TJSPList.splice(index-1,1,row)
            }
        },
        dowTJSPList(row,index) {
             if(index != this.TJSPList.length -1) {
                this.TJSPList[index] = this.TJSPList[index+1]
                var TjArr = []
                TjArr = this.TjlistArr[index + 1]
                this.TjlistArr[index + 1] = this.TjlistArr[index]
                this.TjlistArr[index] = TjArr
                this.TJSPList[index].map(item => {
                    item.flow_index = item.flow_index - 1
                })
                row.map(item => {
                    item.flow_index = item.flow_index + 1
                })
                this.TjlistArr[index].map(item => {
                    item.flow_index = item.flow_index - 1
                })
                this.TjlistArr[index + 1].map(item => {
                    item.flow_index = item.flow_index + 1
                })
                this.TJSPList.splice(index+1,1,row)
            }
        },
        delTJSPList(index,Index) {
            this.TJSPList.splice(index,1)
            this.TjlistArr.splice(Index,1)
        },
        addTJSPList() {
            this.TJSPList.push([])
            this.TjlistArr.push([])
        },
        editTJ(item,index) {
            if (item) {
                this.Tjlist = JSON.parse(JSON.stringify(item)) 
            }
            this.nowTJIndex = index
            this.tjPop = true
        },
        upTo(row,index,item,Index) {
            if (!item) {
                if(index != 0) {
                    this.MData[index] = this.MData[index-1]
                    this.MData[index].step_index =  this.MData[index].step_index + 1
                    row.step_index = row.step_index - 1
                    this.MData.splice(index-1,1,row)
                }
            }
            if (item) {
                if(index != 0) {
                    var outerArr = []
                    outerArr = JSON.parse(JSON.stringify(this.TJSPList[Index]))
                    var SpArr = []
                    SpArr = JSON.parse(JSON.stringify(outerArr[index]))
                    outerArr[index] = JSON.parse(JSON.stringify(outerArr[index-1]))
                    outerArr[index-1] = SpArr
                    outerArr[index].step_index =  outerArr[index].step_index + 1
                    outerArr[index-1].step_index = outerArr[index-1].step_index - 1
                    this.$set(this.TJSPList,Index,outerArr)
                }
            }
            
        },
        dowTo(row,index,item,Index) {
            if (!item) {
                if(index != this.MData.length -1) {
                    this.MData[index] = this.MData[index+1]
                    this.MData[index].step_index = this.MData[index].step_index + 1
                    row.step_index = row.step_index - 1
                    this.MData.splice(index+1,1,row)
                }
            } 
            if (item) {
                if(index != item.length -1) {
                    var outerArr = []
                    outerArr = JSON.parse(JSON.stringify(this.TJSPList[Index]))
                    var SpArr = []
                    SpArr = JSON.parse(JSON.stringify(outerArr[index]))
                    outerArr[index] = JSON.parse(JSON.stringify(outerArr[index+1]))
                    outerArr[index+1] = SpArr
                    outerArr[index].step_index =  outerArr[index].step_index - 1
                    outerArr[index+1].step_index = outerArr[index+1].step_index + 1
                    this.$set(this.TJSPList,Index,outerArr)
                }
            }
            
        },
        insertClick() {
            this.addPop = true
        },
        addUser() {
            this.addPop2 = true
        },
        delItem(index,item,Index) {
            if (item) {
                this.TJSPList[Index].splice(index,1)
                this.$set(this.TJSPList,Index,this.TJSPList[Index])
                var arr = []
                arr = JSON.parse(JSON.stringify(this.TJSPList[Index]))
                this.TJSPList[Index] = arr
            }
            if (!item) {
                this.MData.splice(index,1)
            }
        },
        delUser(index) {
            this.list.splice(index,1)
        } ,
        delOrg(index) {
            this.orgList.splice(index,1)
        } ,
        clickRow(row,index){
             this.$refs.userTable.toggleSelect(index);
             if (!this.$refs.userTable.objData[index]._isChecked) {
                  this.delList.push(row.user_id)
             }
             },
        itemClick(selection) {
                this.selection = selection
             },
        addOrgCom(){
            this.orgFlg = false
            var List1 = []
            this.orgselectList.map((item,index) => {
                var obj = {
                    code: item.code,
                    cname: item.cname
                }
                List1.push(obj)
            })
            List1.map(item => {
                this.orgRemoveArr(item)
            })
            this.orgList = [...this.orgList,...List1]
        },
        addComUser() {
            this.addPop2 = false
            var List1 = []
            this.selection.map((item,index) => {
                var obj = {
                    user_id: item.user_id,
                    user_name: item.user_name
                }
                List1.push(obj)
            })
            List1.map(item => {
                this.RemoveArr(item)
            })
            this.list = [...this.list,...List1]
        },
        addItem() {
           this.$refs['formValidate'].validate((valid) => { 
               if (valid) {
                    // if (this.isMorE || this.isMorY || this.isTJE || this.isTJY) {
                            if (this.addFormItem.auth_type == 'A04') {
                                this.DJZGList.map(item => {
                                    if(item.val == this.addFormItem.auth_value) {
                                        this.addFormItem.auth_name = item.name
                                    }
                                })
                            }
                            else if(this.addFormItem.auth_type == 'A01'){
                                this.addFormItem.auth_name = ''
                                this.addFormItem.auth_value = ''
                                this.list.map((item,index) => {
                                    if (this.list.length == 0) {
                                        this.addFormItem.auth_name = item.user_name
                                        this.addFormItem.auth_value = item.user_id
                                    } else if (this.list.length -1 == index) {
                                        this.addFormItem.auth_name += item.user_name
                                        this.addFormItem.auth_value += item.user_id
                                    } else {
                                        this.addFormItem.auth_name += item.user_name + ','
                                        this.addFormItem.auth_value += item.user_id + ','
                                    }
                                })
                            } else if(this.addFormItem.auth_type == 'A06') {
                                    this.HMXMList.map(item => {
                                        if (item.val == this.addFormItem.auth_name) {
                                            this.addFormItem.auth_name = item.itemName
                                            this.addFormItem.auth_value = item.conditionId
                                        }
                                    })
                            }  else if(this.addFormItem.auth_type == 'A03') {
                                this.addFormItem.auth_name = ''
                                this.addFormItem.auth_value = ''
                                    this.orgList.map((item,index) => {
                                        if (this.orgList.length == 0) {
                                            this.addFormItem.auth_name = item.cname
                                            this.addFormItem.auth_value = item.code
                                        } else if (this.orgList.length -1 == index) {
                                            this.addFormItem.auth_name += item.cname
                                            this.addFormItem.auth_value += item.code
                                        } else {
                                            this.addFormItem.auth_name += item.cname + ','
                                            this.addFormItem.auth_value += item.code + ','
                                        }
                                    })
                            } 
                            else if(this.addFormItem.auth_type == 'E04') {
                                this.SPLXList.map(item => {
                                    if(item.name.includes(this.addFormItem.auth_type)) {
                                        this.addFormItem.auth_name = item.name.split(':')[1]
                                    }
                                })
                            }else if (this.addFormItem.auth_type == 'A09') {
                                if(this.addFormItem.roleValueList.length>0){
                                    this.addFormItem.auth_name = ''
                                    this.addFormItem.auth_value = ''
                                    this.addFormItem.roleValueList.map((item,index) => {
                                    if (this.addFormItem.roleValueList.length -1 == index) {
                                        this.addFormItem.auth_value += item
                                    } else {
                                        this.addFormItem.auth_value += item + ','
                                    }
                                    let data  =  this.roleList.filter(i=>i.roleId == item)
                                    this.addFormItem.auth_name = this.addFormItem.auth_name.length > 0 ? this.addFormItem.auth_name + ',' + data[0].roleDescribe : this.addFormItem.auth_name + data[0].roleDescribe
                                    })
                                }else{
                                    return this.$Message.error("请选择审批角色！")
                                }
                                
                            }
                    // }
                    if (this.isMorA || this.isMorY) {
                        this.addFormItem.step_index = this.MData.length + 1  // 步骤编号,
                        this.addFormItem.flow_index = 0,
                        this.MData.push(JSON.parse(JSON.stringify(this.addFormItem)))
                     }
                    if (this.isMorE) {this.MData.splice(this.nowIndex,1,JSON.parse(JSON.stringify(this.addFormItem)))}
                    if (this.isTJA || this.isTJY) {
                        this.addFormItem.step_index = this.TJSPList[this.nowListIndex].length + 1  // 步骤编号,
                        this.addFormItem.flow_index = this.nowListIndex + 1  ,
                        this.TJSPList[this.nowListIndex].push(JSON.parse(JSON.stringify(this.addFormItem)))
                        var arr = JSON.parse(JSON.stringify(this.TJSPList[this.nowListIndex]))
                         this.TJSPList[this.nowListIndex] = arr
                        }
                    if (this.isTJE) {
                        this.TJSPList[this.nowListIndex].splice(this.nowIndex,1,JSON.parse(JSON.stringify(this.addFormItem))); 
                        var arr = JSON.parse(JSON.stringify(this.TJSPList[this.nowListIndex]))
                        this.TJSPList[this.nowListIndex] = arr
                    }
                    this.addPop = false
               } else {
                    this.$Message.error(this.$t('LeaveApplicationApply.qwztxxxi'));
               }

           })
        }
    }
}
</script>
<style  scoped>
    #aps{
        font-size: 12px;
    }
    .btn_group {
        display: flex;
    }
</style>




// WEBPACK FOOTER //
// src/components/process/SystemSettings/ApprovalProcessSet.vue